import * as React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Layout } from './components/layoutmenu/Layout';
import Home from './components/homepage/Home';
import AdminNavigationPage from './components/adminscreens/AdminNavigationPage';
import AdminDocumentsList from './components/adminscreens/AdminDocumentsList';
import AdminDocumentView from './components/adminscreens/AdminDocumentView';
import AdminNewsList from './components/adminscreens/AdminNewsList';
import AdminNewsView from './components/adminscreens/AdminNewsView';
import AdminFeedbackMessagesPage from './components/adminscreens/AdminFeedbackMessagesPage';
import AdminSitesPage from './components/adminscreens/AdminSitesPage';
import SiteInfoForm from './components/adminscreens/SiteInfoForm';
import SiteDetailForm from './components/adminscreens/SiteDetailForm';
import SiteDetails from './components/site/SiteDetails';
import { PrivateRoute } from './components/routes/PrivateRoute';
import { AdminRoute } from './components/routes/AdminRoute';
import DocumentPage from './components/document/DocumentPage';
import DocumentViewer from './components/document/DocumentViewer';


import Login from './components/signin/Login';
import Logout from './components/signin/Logout';
import AuthComplete from './components/signin/AuthComplete';
import InfoMessagesList from './components/infomessages/InfoMessagesList';
import InfoMessageView from './components/infomessages/InfoMessageView';

export const routes = <Layout>
    <Switch>
        <PrivateRoute exact path='/' component={Home as any} />
        <PrivateRoute exact path='/s/:siteId?' component={SiteDetails as any} />
        <PrivateRoute exact path='/documents/:documentId' component={DocumentViewer as any} />
        <PrivateRoute path='/documents' component={DocumentPage as any} />
        <PrivateRoute path='/infomessages' component={InfoMessagesList} />
        <PrivateRoute exact path='/infomessage/:infoMessageId?' component={InfoMessageView} />
        <AdminRoute path='/administration' component={AdminNavigationPage as any} />
        <AdminRoute path='/administrationdocuments' component={AdminDocumentsList as any} />
        <AdminRoute path='/administrationdocument/:documentId?' component={AdminDocumentView as any} />
        <AdminRoute path='/administrationinfomessages' component={AdminNewsList as any} />
        <AdminRoute path='/administrationinfomessage/:infoMessageId?' component={AdminNewsView as any} />
        <AdminRoute path='/administrationfeedbackmessages' component={AdminFeedbackMessagesPage as any} />
        <AdminRoute path='/administrationsites' component={AdminSitesPage as any} />
        <AdminRoute path='/administrationsiteinfo/:siteId?/:addMode?' component={SiteInfoForm as any} />
        <AdminRoute path='/administrationsitedetail/:siteId?/:cultureId?' component={SiteDetailForm as any} />
        <Route path='/login' component={Login as any} />
        <Route path='/logout' component={Logout as any} />
        <Route path='/auth/complete' component={AuthComplete as any} />
    </Switch>
</Layout>;
